import FeedbackApi from '../api/FeedbackApi';
import {CreateFeedbackPayload} from '../models/Feedback/Feedback';

class FeedbackRepository {
  private feedbackApi = new FeedbackApi();

  public async getFeedbackList(
    organizationId: string,
    page: number,
    pageSize: number,
    search?: string,
  ) {
    return this.feedbackApi.getFeedbackList(
      organizationId,
      page,
      pageSize,
      search,
    );
  }

  public async getFeedback(organizationId: string, feedbackId: string) {
    return this.feedbackApi.getFeedback(organizationId, feedbackId);
  }

  public async createFeedback(
    organizationId: string,
    payload: CreateFeedbackPayload,
  ) {
    return this.feedbackApi.createFeedback(organizationId, payload);
  }

  public async deleteFeedback(organizationId: string, feedbackId: string) {
    return this.feedbackApi.deleteFeedback(organizationId, feedbackId);
  }
}

export default FeedbackRepository;
